export default "__VITE_ASSET__jkxVdI$e__"